export default __webpack_public_path__ + "static/media/jewellery-1.e3f6f6a9.jpg";